import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=e9a36240&"
import script from "./Announcement.vue?vue&type=script&lang=js&"
export * from "./Announcement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9a36240')) {
      api.createRecord('e9a36240', component.options)
    } else {
      api.reload('e9a36240', component.options)
    }
    module.hot.accept("./Announcement.vue?vue&type=template&id=e9a36240&", function () {
      api.rerender('e9a36240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Portal/Announcement.vue"
export default component.exports